import React from "react";
import img4 from "../images/program-antyplagiatowy-wrona-4.png"
import img5 from "../images/program-antyplagiatowy-wrona-5.png"

export const Links2 = () => [
  <div className="default-block container" style={{marginTop: 30, marginBottom: 70}} key={0}>
    <div className="wp-block-columns">
      <div className="default-block container">
        <div className="wp-block-column">
          <a href="https://poprawaprac.pl/poprawa-plagiatu-jsa/" style={{color: 'inherit'}}>
            <img src={img4} alt="Poznaj 4 skuteczne sposoby poprawy plagiatu JSA"/>
          </a>
        </div>
      </div>
      
      <div className="default-block container">
        <div className="wp-block-column">
          <h4 style={{marginTop: 0, textAlign: "left", fontWeight: 600}}>
            <a href="https://poprawaprac.pl/poprawa-plagiatu-jsa/" style={{color: 'inherit', wordBreak: 'normal'}}>Poznaj 4 skuteczne sposoby poprawy plagiatu JSA</a>
          </h4>
          <div>
            Poznaj 4 skuteczne techniki parafrazowania tekstu pod JSA. Pobierz kompleksową instrukcję poprawy plagiatu. Zmień wszystkie fragmenty oznaczone w twoim raporcie i uzyskaj dopuszczalny poziom plagiatu - poniżej 25%.
          </div>
        </div>
      </div>
    </div>
  </div>,
  
  <div className="default-block container" style={{paddingBottom: 40}} key={1}>
    <div className="wp-block-columns">
      <div className="default-block container">
        <div className="wp-block-column">
          <h4 style={{textAlign: "center", fontWeight: 600}}>
            <a href="https://poprawaprac.pl/kontakt/" style={{color: 'inherit', wordBreak: 'normal'}}>Potrzebujesz pomocy?</a>
          </h4>
          <div>
            Uzyskaj ekspresową wycenę!
          </div>
        </div>
      </div>
      
      <div className="default-block container">
        <div className="wp-block-column">
          <a href="https://poprawaprac.pl/kontakt/" style={{color: 'inherit'}}>
            <img alt="Uzyskaj ekspresową wycenę!" src={img5}/>
          </a>
        </div>
      </div>
    </div>
  </div>
];
